<template>
  <div :class="prematriculaFinalizada ? '' : 'fuid-home'">
    <finPrematricula v-if="prematriculaFinalizada" :title="premFin.title" :message="premFin.message" />

    <div v-if="prematriculaFinalizada == false">
      <headerTitle :codigoTraduccion="getLocalizacion[0].codigoTraduccion" />

      <section class="fuid-forms">
        <b-container fluid class="fuid-container__fluid">
          <b-row>
            <b-col>
              <b-tabs class="fuid-tabs-control" content-class="pt-3" @activate-tab="handleTabs" v-model="tabIndex"
                align="center">
                <b-tab ref="tab1">
                  <template #title>
                    <div>
                      {{ $t("tabs.1") }}
                      <span class="nav-item-subtit">{{ $t("tabs.1sub") }}</span>
                    </div>
                  </template>

                  <b-container>
                    <b-row>
                      <b-col>
                        <div v-for="(alumno, index) in alumnos_forms" :key="`alumno-${index}`" :ref="`a-${index}`">
                          <b-row>
                            <section v-if="(alumno.id > 1)" class="fuid-alumnos-action" :key="`alumno-remove-${index}`">
                              <a @click.prevent="alumnoRemove(alumno.id)" href="#"
                                class="d-inline-flex justify-content-center align-items-center"><span
                                  class="d-flex justify-content-center align-items-center">
                                  <alumnoMinus />
                                </span>{{ $t("forms.student.remove") }}</a>
                            </section>
                          </b-row>

                          <alumnoForm :key="`alumno-${index}`" :ref="`a-${index}`" :id="alumno.id"
                            :validate="alumno.validate" @getValidation="setValidation" />
                        </div>

                        <section class="fuid-alumnos-action">
                          <a @click.prevent="alumnoAdd" href="#"
                            class="d-inline-flex justify-content-center align-items-center"><span
                              class="d-flex justify-content-center align-items-center">
                              <alumnoPlus />
                            </span>{{ $t("forms.student.add") }}</a>
                        </section>

                        <section class="d-flex align-intems-center justify-content-center next-step">
                          <button class="fuid-button fuid-button-step" @click.prevent="alumnosNextTab"
                            :disabled="alumnosLoading">
                            {{ $t("tabs.next") }}
                          </button>
                        </section>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-tab>

                <b-tab ref="tab2" :title="$t('tabs.2')">
                  <template #title>
                    <div>
                      {{ $t("tabs.2") }}
                      <span class="nav-item-subtit">{{ $t("tabs.2sub") }}</span>
                    </div>
                  </template>

                  <b-container>
                    <b-row>
                      <b-col>
                        <solicitanteForm ref="applicant" @toFinalStep="toFinalStep" />

                        <section class="d-flex align-intems-center justify-content-center next-step">
                          <button class="fuid-button fuid-button-step" @click.prevent="applicantNextTab"
                            :disabled="applicantLoading">
                            {{ $t("tabs.next") }}
                          </button>
                        </section>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-tab>

                <b-tab ref="tab3" lazy id="final-step">
                  <template #title>
                    <div>
                      {{ $t("tabs.3") }}
                      <span class="nav-item-subtit">{{ $t("tabs.3sub") }}</span>
                    </div>
                  </template>

                  <b-container>
                    <b-row>
                      <b-col>
                        <prematriculaResume ref="resume" @getPrematricula="gettPrematricula"
                          @sendPrematricula="buttonPrematricula" :localizacion="getLocalizacion[0].id" />

                        <section v-if="prematriculaButton"
                          class="d-flex align-intems-center justify-content-center next-step">
                          <button v-if="prematriculaButton" class="fuid-button fuid-button-step"
                            :disabled="prematriculaLoading" @click.prevent="sendPrematricula">
                            <b-spinner v-if="prematriculaLoading" variant="light" label="Loading..."></b-spinner>

                            <span v-else>{{ $t("resume.send") }}</span>
                          </button>
                        </section>
                      </b-col>
                    </b-row>
                  </b-container>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </div>
  </div>
</template>

<script>
// ----------------------------------------------------------
// To map shit from Vuex
// ----------------------------------------------------------
import { mapActions, mapGetters } from "vuex";
// ----------------------------------------------------------
// Mixins
// ----------------------------------------------------------
import scrollTo from "@/mixins/scrollTo";
// ----------------------------------------------------------
// Forms & fields components
// ----------------------------------------------------------
import alumnoForm from "@/components/alumnoForm.vue";
import solicitanteForm from "@/components/solicitanteForm.vue";
import prematriculaResume from "@/components/prematriculaResume.vue";
import headerTitle from "@/components/headerTitle.vue";
import finPrematricula from "@/components/finPrematricula.vue";
import alumnoPlus from "@/assets/svg/alumno-plus.svg";
import alumnoMinus from "@/assets/svg/alumno-minus.svg";

export default {
  data() {
    return {
      tabIndex: 0,
      mobile: this.$isMobile(),
      prematriculaButton: true,
      prematriculaLoading: false,
      applicantLoading: false,
      alumnosLoading: false,
      alumnos_forms: [
        {
          id: 1,
        },
      ],
      alumnos_valid: 0,
      solicitante_valid: false,
      isLoading: false,
      tabsBlocked: false,
      prematriculaFinalizada: null,
      checkPrematriculaFinalizada:
        process.env.VUE_APP_CHECK_PREMATRICULA_FINALIZADA || 1,

      premFin: {
        title: "fin.p1",
        message: "",
      },
    };
  },

  components: {
    alumnoForm,
    solicitanteForm,
    prematriculaResume,
    alumnoPlus,
    alumnoMinus,
    headerTitle,
    finPrematricula,
  },

  async mounted() {
    /**
     * Obtener subdominio desde el que el alumno accede para sacar los datos correspondientes a este
     * y obviar si procede del subdominio de la intranet
     *
     */
    let parts = location.hostname.split(".");
    let subdomain = parts.shift();
    if (subdomain.includes("intranet")) {
      subdomain = subdomain.replace("-intranet", "");
    }

    if (subdomain.includes("test")) {
      subdomain = subdomain.replace("-test", "");
    }

    if (subdomain === "localhost") subdomain = "prematriculas-vitoria";

    // Cambiar texto de mensaje de prematiculas cerradas en funcion de llodio o vitoria
    this.premFin.message = "fin.p2.vitoria";
    if (subdomain.includes("llodio")) this.premFin.message = "fin.p2.llodio";

    await this.fetchLocalizacion(subdomain);
    await this.setCurso();

    this.endPrematricula();
  },

  mixins: [scrollTo],

  computed: {
    ...mapGetters("Localizaciones", ["getLocalizacion"]),
    ...mapGetters("Prematricula", ["getPrematricula"]),
  },

  methods: {
    /**
     * Map actions from Vuex
     *
     */

    ...mapActions("Localizaciones", ["fetchLocalizacion"]),
    ...mapActions("Prematricula", ["setCurso"]),
    ...mapActions("Prematricula", ["clearAlumnos"]),

    /**
     * Se ejecuta cada vez que el usuario intenta cambiar de tab
     *
     */

    handleTabs(newTabIndex, prevTabIndex, bvEvt) {
      /**
       * If prematricula is finished
       *
       */

      if (this.tabsBlocked) {
        bvEvt.preventDefault();
      }

      /**
       * Si vamos a la 1 reseteamos la validacion x si hay cambios
       *
       */

      if (newTabIndex === 0) {
        this.alumnos_valid = 0;

        // Remove all the data of the alumnos of the Prematricula store
        this.alumnos_forms.forEach((e, i) => {
          this.$refs[`a-${i}`][0].clearPrematriculaStore();
        });
      }

      /**
       * Si vamos a la 2 el solicitante tiene que ser valido
       *
       */

      if (newTabIndex === 2) {
        if (this.solicitante_valid !== true) {
          bvEvt.preventDefault();
        } else {
          if (this.mobile) {
            let el = document.getElementById("final-step");
            this.scrollIt(el);
          }
        }
      }

      /**
       * Si vamos de la 1 a la 2 antes validamos todos los alumnos
       *
       */

      if (prevTabIndex === 0) {
        if (this.alumnos_valid === 0) {
          bvEvt.preventDefault();

          this.triggerAlumnosValidation();
        }
      }
    },

    /**
     * Añade un form de alumno más
     *
     */

    alumnoAdd() {
      this.alumnos_forms.push({
        id: this.alumnos_forms.length + 1,
      });
    },

    alumnoRemove(id) {
      this.alumnos_forms.splice(this.alumnos_forms.findIndex(alumno => parseInt(alumno.id) === parseInt(id)), 1)
    },

    /**
     * Dispara la validación en todos los alumnos
     *
     */

    triggerAlumnosValidation() {
      //this.clearAlumnos()

      this.alumnos_forms.forEach((e, i) => {
        this.$refs[`a-${i}`][0].submit();
      });
    },

    /**
     * Applicant form validation
     *
     */

    triggerApplicantValidation() {
      this.$refs["applicant"].submit();
    },

    /**
     * Boton de continuar alumnos tab
     *
     */

    alumnosNextTab() {
      this.alumnosLoading = true;

      this.alumnos_valid = 0;

      this.triggerAlumnosValidation();
    },

    /**
     * Boton de continuar applicant tab
     *
     */
    applicantNextTab() {
      this.applicantLoading = true;

      this.triggerApplicantValidation();
    },

    /**
     * Se ejecuta cada vez que el validamos un alumno
     * Se recibe cuando se ejecuta submit en el children
     * Recibe un objeto data con el id y un booleano
     */

    setValidation(data) {
      /**
       * Si el alumno existe y su form esta validado sumamos 1 a alumnos_valid
       *
       */

      let alumno = this.alumnos_forms.find((x) => x.id === data.id);

      if (typeof alumno !== "undefined" && data.valid === true) {
        this.alumnos_valid++;
      }

      this.alumnosLoading = false;
    },

    /**
     * When the solicitant is ready
     *
     */

    toFinalStep(data) {
      if (data.valid === true) {
        this.solicitante_valid = true;
        this.tabIndex = 2;
      }

      this.applicantLoading = false;
    },

    /**
     * Send the prematricula
     *
     */

    sendPrematricula() {
      this.$refs.resume.submit();
    },

    /**
     * Get the prematricula
     *
     */

    gettPrematricula(data) {
      this.prematriculaButton = false;

      if (data.valid == true) {
        this.tabsBlocked = true;
      }
    },

    buttonPrematricula(data) {
      if (data.value == true) {
        this.prematriculaLoading = true;
      }

      if (data.value == false) {
        this.prematriculaLoading = false;
      }
    },

    /**
     * Determina si el periodo de prematricula ha terminado
     *
     */
    endPrematricula() {

      if (this.checkPrematriculaFinalizada == 0) {
        this.prematriculaFinalizada = false;
        return;
      }

      let d = new Date();

      this.prematriculaFinalizada = true;
      if (
        (this.getLocalizacion[0].ultimoCurso.fechaInicioPrematriculaFase2.split('T')[0] <= d.toISOString().split('T')[0] && d.toISOString().split('T')[0] <= this.getLocalizacion[0].ultimoCurso.fechaFinPrematriculaFase2.split('T')[0])
        ||
        (this.getLocalizacion[0].ultimoCurso.fechaInicioPrematriculaFase3.split('T')[0] <= d.toISOString().split('T')[0] && d.toISOString().split('T')[0] <= this.getLocalizacion[0].ultimoCurso.fechaFinPrematriculaFase3.split('T')[0])
      ) {
        this.prematriculaFinalizada = false;
      }
    },
  },

  watch: {
    alumnos_valid: function (value) {
      /**
       * Si los alumnos validos son iguales al numero de alumnos
       * Dejamos pasar a la pestaña 2 si vuelve a la 1
       * volveremos a validar x si hay cambios
       */

      if (this.alumnos_valid === this.alumnos_forms.length) {
        this.tabIndex = 1; // ir a la pestaña 2
      }
    },
  },
};
</script>
